import React, { memo } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import moment from 'moment';

import locale from 'antd/es/date-picker/locale/fr_FR';

import { Form, DatePicker, Col } from 'antd';

function DateField({
  mode,
  data,
  index,
  format,
  value,
  onlyRead,
  // actions
  onChange,
  disabledDate,
  // default
  className
}) {
  const childClassNames = classNames('custom-form-column', 'date-input-column');
  const mainClass = data?.name + '-wrapper';
  const childClassNamesFiled = classNames(mainClass, className);
  const label = data?.displayLabel ? data?.label : data?.label;
  const onlyReadLabel = data?.onlyReadLabel;

  return data && (
    <Col
      key={data?.name + index + '-col'}
      md={data?.col || 24}
      xs={24}
      offset={data?.offset || null}
      className={childClassNames}
    >
      <Form.Item
        key={data?.name + index + '-item'}
        label={onlyRead ? onlyReadLabel :label}
        name={data?.name}
        className={childClassNamesFiled}
        selected={moment()}
        initialValue={
          data?.value ? moment(data?.value, format) : null
        }
        rules={[
          {
            required: data?.required || false,
            message: `Veuillez sélectionner l'heure`,
          },
        ]}
      >
        <DatePicker
          mode={mode}
          format={format}
          onChange={onChange}
          disabledDate={disabledDate}
          value={value || (data?.value ? moment(data?.value, format) : null)}
          locale={{
            ...locale,
            lang: {
              ...locale.lang,
              today: 'Aujourd’hui',
              now: 'À présent',
              ok: 'Ok',
            },
          }}
        />
      </Form.Item>
    </Col>
  );
};

DateField.defaultProps = {
  index: 1,
  format: 'DD.MM.YYYY',
  mode: 'date',
};

DateField.propTypes = {
  data: PropTypes.oneOfType([
    PropTypes.bool.isRequired,
    PropTypes.object.isRequired,
  ]),
  onChange: PropTypes.func,
  disabledDate: PropTypes.func,
};

export default memo(DateField);